module.exports = __webpack_public_path__ + "assets/img/bash_full_colored_light.ba9c1604.svg";